import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { BehaviorSubject, Observable } from 'rxjs';

import { environment } from 'environments/environment';
import { AuthenticationService } from '../authentication/authentication.service';
import { Service } from './service';

@Injectable()
export class ServiceService implements Resolve<any> {
  public rows: any;
  public onServiceListChanged: BehaviorSubject<any>;

  constructor(private _httpClient: HttpClient, public _authenticationService: AuthenticationService) {
    this.onServiceListChanged = new BehaviorSubject({});
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    return new Promise<void>((resolve, reject) => {
      Promise.all([this.getAllServices()]).then(() => {
        resolve();
      }, reject);
    });
  }

  getAllServices(ignoreSubjects = false): Promise<Service[]> {
    const headers = this._authenticationService.getAccessTokenHeader();
    return new Promise((resolve, reject) => {
      this._httpClient.get(`${environment.apiUrl}/v1/services`, { headers }).subscribe((response: any) => {
        this.rows = response.results;
        if (!ignoreSubjects) {
          this.onServiceListChanged.next(this.rows);
        }
        resolve(this.rows);
      }, reject);
    });
  }

  createService(service): Promise<void> {
    delete service.id;
    const headers = this._authenticationService.getAccessTokenHeader();
    return new Promise((resolve, reject) => {
      this._httpClient.post(`${environment.apiUrl}/v1/services`, service, { headers }).subscribe((response: any) => {
        this.getAllServices();
        resolve();
      }, reject);
    });
  }

  updateService(service): Promise<void> {
    delete service.ownedBy;
    const headers = this._authenticationService.getAccessTokenHeader();
    return new Promise((resolve, reject) => {
      this._httpClient.patch(`${environment.apiUrl}/v1/services/${service.id}`, service, { headers }).subscribe((response: any) => {
        this.getAllServices();
        resolve();
      }, reject);
    });
  }
}
